import { render, staticRenderFns } from "./yf.vue?vue&type=template&id=e53abe10&scoped=true"
import script from "./yf.vue?vue&type=script&lang=js"
export * from "./yf.vue?vue&type=script&lang=js"
import style0 from "./yf.vue?vue&type=style&index=0&id=e53abe10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53abe10",
  null
  
)

export default component.exports